// ToastContext.js
import React, { createContext, useContext, useMemo } from 'react';
import { notification } from 'antd';
import { Box, Typography } from '@mui/material';
import CustomIcon from '../Components/CustomIcon';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
    const [api, contextHolder] = notification.useNotification();

    const openNotification = ({ text, placement = 'bottomLeft', icon = "" }) => {
        api.info({
            message: (<Typography variant='fw400s14cfff' sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}> {text} </Typography>),
            className: "app_toast_v1",
            style: {
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                borderRadius: '6px',
                flexWrap: 'nowrap',
                backgroundColor: '#2E2E2E',
                padding: '16px 24px',
                width: 'fit-content',
                margin: 0
            },
            icon: icon ? <CustomIcon fontSize={'20px'} name={icon} /> : <></>,
            closeIcon: <></>,
            placement,
            duration: 1.5,
        });
    };

    const value = useMemo(() => ({ openNotification }), []);

    return (
        <ToastContext.Provider value={value}>
            {contextHolder}
            {children}
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) throw new Error("useToast must be used within a ToastProvider");
    return context;
};
